import api from 'api'

type AddExclusionRequest = {
  ruleId: number
  placeGeoid: string
}

export const addExclusion = async (
  request: AddExclusionRequest
): Promise<void> => {
  await api.post(`/admin/wage/rules/${request.ruleId}/exclusions`, {
    placeGeoid: request.placeGeoid,
  })
}
